// extracted by mini-css-extract-plugin
export default {"root":"style_root__bkxPi","cover":"style_cover__DbGkX","thumb":"style_thumb__jZS3X","input":"style_input__1Go6e"};